import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Inmueble } from "../../models/trust/empleado/Inmueble";
import { BienInmuebleService } from "../../service/trust/empleado/BienInmuebleService";
import { CatalogoService } from "../../service/CatalogoService";

export const BienInmueble = ({ toast, id, catalogos, permss, soloLectura }) => {

    const omodel = new Inmueble();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const menuRef = useRef(null);
    const [otroInmueble, setOtroInmueble] = useState(false);

    const bienInmuebleSrv = new BienInmuebleService();
    const catalogoService = new CatalogoService();
    const tablaInmueble = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue, watch } = useForm({ defaultValues });
    const { inText, inDrop, inCalendar, inArea, inNumber } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    const fechaAdquisicionWatcher = watch('fecha_adquisicion');
    const fechaRegistroWatcher = watch('fecha_registro_propiedad');

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaInmueble.lazyParams, id]);

    const loadLazyData = () => {
        tablaInmueble.setLoading(true);
        const _params = { ...tablaInmueble.lazyParams, idp: id };
        bienInmuebleSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaInmueble.setTotalRecords(res.data.total);
            tablaInmueble.setData(res.data.registros);
        }).finally(() => tablaInmueble.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setEcuador(false);
        setCiudades([]);
        setDialogVisible(true);
        setOtroInmueble(false);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.ec = catalogos?.ecuador;
        data.otro_inmueble = catalogos?.otro_inmueble;
        data.fecha_adquisicion = generic.dateToString(data.fecha_adquisicion);
        data.fecha_registro_propiedad = generic.dateToString(data.fecha_registro_propiedad);

        const request = getValues('id') == null
            ? bienInmuebleSrv.nuevo(data)
            : bienInmuebleSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        bienInmuebleSrv.consultar(idReg).then(res => {
            const _data = res.data.bien_inmueble;
            setEcuador(_data.pais?.cat_id === catalogos?.ecuador?.cat_id);
            if (res.data.ciudades) setCiudades(res.data.ciudades);
            _data.fecha_adquisicion = generic.stringToDate(_data.fecha_adquisicion);
            _data.fecha_registro_propiedad = generic.stringToDate(_data.fecha_registro_propiedad);
            setOtroInmueble(_data.tipo_bien?.cat_id === catalogos?.otro_inmueble?.cat_id);
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar este bien inmueble?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                bienInmuebleSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const onChangePais = (e) => {
        setEcuador(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia', null);
        setValue('ciudad', null);
        setValue('canton', '');
        setCiudades([]);
    };

    const onChangeProvincia = (e) => {
        setValue('ciudad', null);
        if (!e?.value) { setCiudades([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudades(res.data));
    };

    const onChangeTipoBien = (e) => {
        const esOtro = e.value?.cat_id === catalogos?.otro_inmueble?.cat_id;
        setOtroInmueble(esOtro);
        if (!esOtro) {
            setValue('otro_bien', '');
        }
    }

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_inmueble" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Bienes Inmuebles
            </span>
        </div>
    );

    return (
        <div className="componente-bien-inmueble">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_inmueble" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaInmueble} datos={tablaInmueble.data} totalRegistros={tablaInmueble.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nuevo Bien Inmueble" : "Editar Bien Inmueble"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '720px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-home text-primary"></i>
                                    BIEN INMUEBLE
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inDrop('tipo_bien', catalogos?.tipo_bien, { lab: omodel.optionLabel, chn: onChangeTipoBien }, otroInmueble ? 4 : 6)}
                        {otroInmueble && inText('otro_bien', { icon: 'pi pi-info-circle' }, 4)}
                        {inNumber('valor_bien', 2, false, { prefix: '$ ' }, otroInmueble ? 4 : 6)}
                        {inCalendar('fecha_adquisicion', { maxDate: fechaRegistroWatcher ? new Date(fechaRegistroWatcher) : new Date() }, 6)}
                        {inCalendar('fecha_registro_propiedad', { minDate: fechaAdquisicionWatcher ? new Date(fechaAdquisicionWatcher) : null, maxDate: new Date() }, 6)}
                        {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais }, 4)}
                        {ecuador ? (
                            <>
                                {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia }, 4)}
                                {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 4)}
                            </>
                        ) : (
                            inText('canton', { icon: 'pi pi-map-marker' }, 8)
                        )}
                        {inText('numero_predio_referencia', { icon: 'pi pi-hashtag' }, 12)}
                        {inArea('direccion', 3, 250, 12)}
                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col-auto p-0 m-0">
                                    <Button label="Cerrar" style={{ width: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>
                    </div>
                </form>
            </Dialog>
        </div>
    );
};
